import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const commonStateToken = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        align_items: 'center',
        padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
        gap: FOUNDATIONS.spacing_150,
        cursor: 'pointer',
        border_radius: FOUNDATIONS.radius_comp_forms_filemanager_radiussize,
        overflow: 'visible',
        background_color: FOUNDATIONS.color_comp_forms_filemanager_bg,
        ...STATE_TOKENS?.container,
    },
    loaderContainer: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        pointer_events: 'none',
        overflow: 'visible',
        ...STATE_TOKENS?.loaderContainer,
    },
    loaderPasive: {
        stroke: FOUNDATIONS.color_comp_forms_filemanager_border,
        strokeWidth: FOUNDATIONS.border_50,
        strokeDasharray: '5',
        fill: 'transparent',
        rx: FOUNDATIONS.radius_comp_forms_filemanager_radiussize,
        ry: FOUNDATIONS.radius_comp_forms_filemanager_radiussize,
        height: '100%',
        width: '100%',
        ...STATE_TOKENS?.loaderPasive,
    },
    loader: {
        stroke: FOUNDATIONS.color_accent_loading_secondary_border_50,
        strokeWidth: FOUNDATIONS.border_125,
        fill: 'transparent',
        rx: FOUNDATIONS.radius_comp_forms_filemanager_radiussize,
        ry: FOUNDATIONS.radius_comp_forms_filemanager_radiussize,
        transition: 'stroke-dashoffset 250ms ease-in-out',
        ...STATE_TOKENS?.loader,
    },
    textContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'flex-start',
        ...STATE_TOKENS?.textContainer,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS?.title,
    },
    subtitle: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_100,
        ...STATE_TOKENS?.subtitle,
    },
    fileIconContainer: {
        ...STATE_TOKENS?.fileIconContainer,
    },
    fileIcon: {
        color: FOUNDATIONS.color_comp_forms_filemanager_icon,
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
        ...STATE_TOKENS?.fileIcon,
    },
    actionIconContainer: {
        margin_left: 'auto',
        ...STATE_TOKENS?.actionIconContainer,
    },
    actionIcon: {
        color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        ...STATE_TOKENS?.actionIcon,
    },
    errorContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_100,
        padding_top: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS?.errorContainer,
    },
    errorIcon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_feedback_error_icon_50,
        ...STATE_TOKENS?.errorIcon,
    },
    errorText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_feedback_error_font_50,
        ...STATE_TOKENS?.errorText,
    },
});
//# sourceMappingURL=commonStateTokens.js.map